import { FFullMoment } from 'graphql/fragment/__generated__/FFullMoment';
import { getSmallerImage } from 'libs/utils/imageUtils/imageUtils';
import { IVariantIconV2WorldMarker } from 'react-give-me-map';

import { DEFAULT_MAP_IMAGES } from 'hooks/map/usePreloadDefaultImages';
import { IIndoorStandWorldMarker } from 'react-give-me-map';

export function mapIndoorStandForViewAndEdit(
    marker: IIndoorStandWorldMarker
): IIndoorStandWorldMarker {
    const hasBooking = marker.hasBookingConfiguration;

    if (!hasBooking) {
        return marker;
    }

    const pinSrc = marker.isBookingAvailable
        ? DEFAULT_MAP_IMAGES.indoorStandGreen
        : DEFAULT_MAP_IMAGES.indoorStandRed;

    return {
        ...marker,
        elementData: {
            ...marker.elementData,
            pinSrc
        }
    };
}

export function mapVariantIconForViewAndEdit(
    marker: IVariantIconV2WorldMarker,
    stories: FFullMoment[]
): IVariantIconV2WorldMarker {
    if (marker.storyIds?.length === 1 && marker.elementData.useStoryImage) {
        const story = stories.find((e) => marker.storyIds?.[0] === e.storyId);
        return {
            ...marker,
            elementData: {
                ...marker.elementData,
                storyImageUrl: getSmallerImage(story?.header?.imageUrl, 200)
            }
        };
    }

    return marker;
}
